import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card, Alert, Image, Tooltip, OverlayTrigger, Accordion, Table, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

// import { getScenarioGroupStatus } from './../../../../actions/closeLoop/validation/index';
// import Loader from './../../../../utilityComponents/MiniLoader';
import Loader from './../../../../../utilityComponents/MiniLoader';

import { getScenarioGroupStatus } from '../../../../../actions/openLoop/validation';

const statusCheck = require('./../../../../../images/validation/status-check.png');


function StatusCheck() {
    return (
        <Row style={{ alignItems: 'center' }}>
            <Col lg={8} xs={8}>
                <h2>Status : </h2>
            </Col>
            <Col>
                <Image src={statusCheck} style={{ width: "30%" }}/>
            </Col>
        </Row>
    )
}


function ScenarioGroupValidator(props) {

    useEffect(() => {
        if (props.topologyId) {
            console.log("props.topologyId", props.topologyId);
            props.fetchScenarioGroupStatus(props.topologyId);
        }
    }, [props.topologyId])

    console.log("Scenario Group Validator Props : ", props);

    return (
        <>
            <Row>
                <Col lg={12} xs={12}>
                    <OverlayTrigger
                        key='top'
                        placement='top'
                        overlay={
                            <Tooltip
                                id="tooltip-top"
                            >
                                <strong>{props.title} Check</strong>
                            </Tooltip>
                        }
                    >
                        <Card border="secondary">
                            <Row style={{ textAlign: "center" }}>
                                <Col ls={12} xg={12}>
                                    <Card.Img variant="top" src={props.icon} style={{ width : '200px', height: '200px' }}/>
                                </Col>
                            </Row>
                            <Card.Body>
                                <Card.Title>{ props.title } Check</Card.Title>
                                <Card.Text>
                                    { props && props.topologyId !== '' && props.topologyId !== 'na' && props.topologyId !== null && props.topologyId !== undefined ? (
                                        Object.keys(props['validation']).length ? ( (props['validation'][props.topologyId] && Object.keys(props['validation'][props.topologyId]).length)  ? (
                                                ( props["validation"][props.topologyId]['loading'] ? <Loader /> : props['validation'][props.topologyId]['error'] ?
                                              (<Alert key='danger' variant='danger'>
                                                  { props['validation'][props.topologyId]['error'] }
                                               </Alert>) : (
                                                <>
                                                    <StatusCheck />

                                                    { Object.keys(props['validation']).length ? ( Object.keys(props['validation'][props.topologyId]).length ? (
                                                        Object.keys(props['validation'][props.topologyId]['info']).length ? (
                                                            props['validation'][props.topologyId]['info']['scenario_group'].length ? (
                                                                <Accordion>
                                                                    <Card>
                                                                        <Card.Header>
                                                                            <Accordion.Toggle as={Button}  eventKey='scenarioGroup'>
                                                                               Scenario Group #
                                                                            </Accordion.Toggle>
                                                                        </Card.Header>
                                                                    <Accordion.Collapse eventKey='scenarioGroup'>
                                                                        <Card.Body>
                                                                            <Table striped bordered hover>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>#</th>
                                                                                        <th>Group Name</th>
                                                                                        <th>Number of scenario</th>
                                                                                        <th>Group Count</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {props['validation'][props.topologyId]['info']['scenario_group'].map((element, eIndex) => (
                                                                                        <tr key={eIndex}>
                                                                                            <td>{eIndex}</td>
                                                                                            <td>{element['group_name']}</td>
                                                                                            <td>{element['scenario_count']}</td>
                                                                                            <td>{element['occurrence']}</td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </Table>
                                                                        </Card.Body>
                                                                    </Accordion.Collapse>
                                                                    </Card>
                                                                </Accordion>
                                                            ) : (
                                                                <Alert variant='danger'>Error occurred while fetching this request1</Alert>
                                                            )
                                                        ) : undefined
                                                    ) : undefined ) : undefined }
                                                </>
                                               ) )
                                        ) : undefined ) : undefined
                                    ) : (<Alert key='danger' variant='danger'>
                                             Error occurred while processing this request!
                                         </Alert>) }
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </OverlayTrigger>
                </Col>
            </Row>
        </>
    )
}

ScenarioGroupValidator.defaultProps = {
    topologyId: '',
    icon: ''
};

ScenarioGroupValidator.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    topologyId: PropTypes.string.isRequired,
    validation: PropTypes.shape({}),
    fetchScenarioGroupStatus: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
    validation: state.axios
});

const mapDispatchToProps = (dispatch) => ({
    fetchScenarioGroupStatus: (payload) => dispatch(getScenarioGroupStatus(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ScenarioGroupValidator);
